<template>
  <div ref="summary" class="summary-wrapper">
    <div class="summary">
      <div class="summary__header">
        <span class="summary__title">{{
          __('Estimated volume:', 'smdt')
        }}</span>

        <span class="summary__count" :class="{ active: count }">
          <span class="summary__count__number">{{ sum }}</span> m<sup
            >3</sup
          ></span
        >
        <span class="summary__title inventory">{{
          __('Your inventory:', 'smdt')
        }}</span>
        <div v-if="Object.keys(values.rooms).length" class="inventories"></div>
      </div>
      <div v-auto-animate class="summary__inventories">
        <template v-for="inventory in inventories" :key="inventory.slug">
          <SmallInventoryItem :inventory="inventory" />
        </template>
      </div>
    </div>
    <div class="summary-buttons">
      <button type="button" class="sum-nav sum-nav__prev" @click="goStep(2)">
        {{ __('Previous step', 'smdt') }}
      </button>
      <button
        type="button"
        class="sum-nav sum-nav__next"
        :disabled="!canNext"
        @click="goStep(4)"
      >
        {{ __('Next step', 'smdt') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia'
import hcSticky from 'hc-sticky'
import SmallInventoryItem from './SmallInventoryItem.vue'

// eslint-disable-next-line no-undef
const { __, sprintf, _n } = wp.i18n

import { mapWritableState, mapState } from 'pinia'
import { useStagesStore } from '../stores/stages'

export default {
  name: 'InventorySummary',
  components: { SmallInventoryItem },
  computed: {
    ...mapWritableState(useStagesStore, ['values', 'currentStage']),
    ...mapState(useStagesStore, ['stages', 'inventories', 'canNext']),
    sum() {
      const sum = this.inventories.reduce((acc, cur) => {
        return acc + cur.size * 1 * cur.count
      }, 0)

      return sum.toFixed(2)
    },
    count() {
      const sum = this.inventories.reduce((acc, cur) => {
        return acc + cur.count * 1
      }, 0)

      return sum
    },
    valid() {
      return this.sum > 0 || this.values.moveMeter || this.values.inventoryInformation
    },
  },
  watch: {
    sum(newVal) {
      this.values.inventorySum = newVal
    },
    valid: {
      handler(newVal) {
        this.setValid(newVal)
      },
      immediate: true,
    },
  },
  mounted() {
    this.values.inventorySum = this.sum

    let offset = 75
    const adminBar = document.getElementById('wpadminbar')
    if (adminBar) {
      offset += adminBar.clientHeight
    }

    new hcSticky(this.$refs.summary, {
      top: offset,
      bottom: 15,
      responsive: {
        991: {
          disable: true,
        },
      },
    })
  },
  methods: {
    ...mapActions(useStagesStore, ['setValid', 'goStep']),
    __,
    sprintf,
    _n,
  },
}
</script>

<style scoped lang="scss">
.summary-wrapper {
  @include media-breakpoint-down(lg) {
    position: fixed;
    left: 0;
    width: 100%;
    top: var(--wp-adminbar-height);
  }
}

.summary {
  background-color: #fff;
  padding: 10px 10px 30px;

  @include media-breakpoint-down(lg) {
    padding: 0;
  }

  &__header {
    padding: 20px 0;

    @include media-breakpoint-down(lg) {
      padding: 15px 20px;
    }
  }

  &__title.inventory {
    @include media-breakpoint-down(lg) {
      display: none;
    }
  }

  &__count {
    display: block;
    margin: 0 0 5px;
    font-size: 16px;
    font-weight: 700;
    color: var(--vn-secondary-color);

    @include media-breakpoint-down(lg) {
      color: #c4c4c4;
    }

    &.active {
      @include media-breakpoint-down(lg) {
        color: var(--vn-secondary-color);
      }
    }

    &__number {
      font-size: 30px;
      @include media-breakpoint-down(lg) {
        font-size: 25px;
      }
    }
  }

  &__inventories {
    @include media-breakpoint-down(lg) {
      display: none;
    }
  }
}

.summary-buttons {
  @include media-breakpoint-down(lg) {
    display: flex;
    align-items: center;
  }
}

.sum-nav {
  @include reset-btn;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  font-weight: 700;
  width: 100%;
  margin-top: 10px;

  @include media-breakpoint-down(lg) {
    margin-top: 0;
    width: 50%;
  }

  &:disabled {
    background-color: lighten(#e2001a, 40%);
    cursor: not-allowed;
  }

  &__prev {
    background-color: #fff;

    @include media-breakpoint-down(lg) {
      background-color: #f4f4f4;
    }
  }

  &__next {
    background-color: var(--vn-secondary-color);
    color: #fff;
  }
}

.devis-btn {
  width: 100%;
  margin-top: 10px;
}
</style>
